import React, { useEffect, useState } from "react";
import { Db } from "./../firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

const PostList = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const snapshot = await getDocs(collection(Db, "posts"));
        const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setPosts(data);
      } catch (err) {
        console.error("Error loading posts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Σίγουρα θέλεις να διαγράψεις αυτό το άρθρο;")) return;

    try {
      await deleteDoc(doc(Db, "posts", id));
      setPosts((prev) => prev.filter((p) => p.id !== id));
      alert("Το άρθρο διαγράφηκε επιτυχώς!");
    } catch (err) {
      console.error("Error deleting post:", err);
      alert("Σφάλμα κατά τη διαγραφή.");
    }
  };

  return (
    <div>
      <h3 className="mb-4">📰 Full Archive</h3>

      {loading ? (
        <p>Φόρτωση...</p>
      ) : posts.length === 0 ? (
        <p>Δεν υπάρχουν άρθρα προς το παρόν.</p>
      ) : (
        <table className="table table-dark table-striped align-middle">
          <thead>
            <tr>
              <th>Title</th>
              <th>Category</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((p) => (
              <tr key={p.id}>
                <td>{p.title || "—"}</td>
                <td>{p.category || "—"}</td>
                <td>
                  {p.createdAt?.toDate
                    ? p.createdAt.toDate().toLocaleDateString("el-GR")
                    : "—"}
                </td>
                <td>
                  <button className="btn btn-warning btn-sm me-2">
                    ✏️ Edit
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(p.id)}
                  >
                    🗑️ Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PostList;
